<template>
	<div class="RemoveView" :to="to" :class="modes.map((m) => `RemoveView--${m}`)">
		<router-link class="RemoveViewButton" @click="$emit('click', $event)" :to="to" v-if="!!to">
			<svg-view name="close" />
		</router-link>
		<div class="RemoveViewButton" @click="$emit('click', $event)" v-else>
			<svg-view name="close" />
		</div>
	</div>
</template>

<script>
export default {
	name: "RemoveView",
	props: {
		to: { type: Object, default: null },
		modes: { type: Array, default: () => [] },
	},
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .RemoveView;

@{r} {
	position: absolute;
	top: 5px;
	left: -50px;
	z-index: 10;

	&:hover {
		opacity: 0.7;
	}

	&Button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		border-radius: 100%;
		overflow: hidden;
		cursor: pointer;
		z-index: 10;

		svg {
			width: 100%;
			height: 100%;
			display: block;
			transition: fill 0.2s;
			fill: @color-black;
			padding-top: 1px;
		}
	}

	&--top {
		top: 55px;
	}

	&--center {
		top: 15px;
	}

	&--bottom {
		top: auto;
		bottom: 6px;
	}
}
</style>
